export default {
  title: 'signupClinics.title',
  inputLabel1: 'signupClinics.inputLabel1',
  inputLabel2: 'signupClinics.inputLabel2',
  inputLabel3: 'signupClinics.inputLabel3',
  inputLabel4: 'signupClinics.inputLabel4',
  inputLabel5: 'signupClinics.inputLabel5',
  inputLabel6: 'signupClinics.inputLabel6',
  inputLabel7: 'signupClinics.inputLabel7',
  buttonText: 'signupClinics.buttonText',
};
